module.exports = __webpack_public_path__ + "static/hero1-f5a9303f9c246e71d259b9f8b1042a2f.png";